import { PUBLIC_ROUTE } from "../../../../route.constants";
import { smoothScroll } from "../../../../utils/helpers/smoothScroll";
import { setupLoanRoute } from "../../../../utils/helpers/navigators";
import { convertDomainToCorrespondingBrand } from "@utils/helpers/convertDomainToCorrespondingBrand";

const shouldRouteBeActive = (loanFormState) => {
  const { brand } = loanFormState.initialValue || "";

  const convertedBrandName = convertDomainToCorrespondingBrand();

  return brand !== convertedBrandName;
};

const navigateTo = (navigate) => {
  navigate(PUBLIC_ROUTE.LANDING);
  window.location.reload();
  smoothScroll();
};

export const mismatchedBrandNavigation = setupLoanRoute({
  shouldRouteBeActive,
  navigateTo,
});
